import { FormOutlined } from '@ant-design/icons';

import BaseNodeContainer from '../../BaseNodeContainer';

export default function FieldNode(node: any) {

  return (
    <BaseNodeContainer
      title={"Input"}
      node={node}
      IconComponent={<FormOutlined />}
      onPressLink={node.onPressAddLinkedNode}
      defaultMessages={node.defaultMessages}
      defaultInputInstructions={node.defaultInputInstructions}
    />
  );
}